import { Link } from 'react-router-dom'
import { GMIcon } from '@/assets'
import GTranslate from '@/components/GTranslate'
import { useLanguage } from '@afsa/shared'
import { useState } from 'react'

export const TopBar = () => {
  const { t } = useLanguage()
  const [showLangPanel, setShowLangPanel] = useState(false)

  return (
      <div className="bg-gray-50 fixed h-14 flex items-center w-full top-0 left-0 right-0 z-50">
        <div className="max-w-[1440px] w-full mx-auto flex items-center justify-between px-4 sm:px-6 lg:px-8">
          

            {/* LEFT SIDE (same for both) */}
            <Link to="/" className="flex items-center gap-2">
              <img src={GMIcon} alt="GM" className="h-5 w-5" />
              <span className="text-gray-600 text-sm font-medium font-satoshi">
                {t('welcome_to_afsa')}
              </span>
            </Link>

            {/* DESKTOP RIGHT SIDE */}
            <div className="hidden lg:flex items-center relative">
              <GTranslate />
            </div>


<div className="flex items-center gap-4 relative lg:hidden">
  {/* MOBILE RIGHT SIDE */}
            <button
              className="p-2 text-gray-700"
              onClick={() => setShowLangPanel(v => !v)}
              aria-label="toggle language"
            >
              {showLangPanel ? (
                <span className="">✕</span>
              ) : (
                <span className="">☰</span>
              )}
            </button>

               {/* MOBILE LANGUAGE PANEL (ONLY GTranslate) */}
      <div
        className={`transition-all duration-300 ${
          showLangPanel ? 'absolute right-2 block top-full z-50 ' : 'hidden'
        }`}
      >
          <GTranslate />
      </div>
</div>
            

        </div>
      </div>

   
   
  )
}

// import { Link } from 'react-router-dom'
// import { GMIcon } from '@/assets'
// import GTranslate from '@/components/GTranslate'
// import { useLanguage } from '@afsa/shared'
// import { useState } from 'react'
// import { useIsMobile } from '@/hooks/useIsMobile'

// export const TopBar = () => {
//   const { t } = useLanguage()

//   const isMobile = useIsMobile()
//   const [isLangOpen, setIsLangOpen] = useState(false)

//   const toggleLang = () => setIsLangOpen(v => !v)
//   const closeLang = () => setIsLangOpen(false)

//   return (
//     <div className="bg-gray-50 fixed top-0 left-0 right-0 z-50">
//       <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">

//         <div className="flex items-center justify-between py-3">

//           {/* LEFT */}
//           <Link to="/" className="flex items-center gap-2">
//             <img src={GMIcon} alt="GM" className="h-5 w-5" />
//             <span className="text-gray-600 text-sm font-medium font-satoshi">
//               {t('welcome_to_afsa')}
//             </span>
//           </Link>

//           {/* DESKTOP: always visible */}
//           {!isMobile && (
//             <div className="flex items-center">
//               <GTranslate />
//             </div>
//           )}

// <div className="flex items-center gap-4 relative">
// {/* MOBILE: toggle */}
//           {isMobile && (
//             <button
//               className="p-2 text-gray-700"
//               onClick={toggleLang}
//               aria-label="toggle language"
//             >
//               {isLangOpen ? (
//                 <span className="text-sm">✕</span>
//               ) : (
//                 <span className="text-sm">☰</span>
//               )}
//             </button>
//           )}

//           {/* MOBILE DROPDOWN (absolute anchored) */}
//           {isMobile && isLangOpen && (
//             <div className="absolute right-0 block top-full mt-2 z-50 bg-white ">
//                 <GTranslate />
//             </div>
//           )}
// </div>
          

//         </div>
//       </div>
//     </div>
//   )
// }